import { useState, useEffect } from "react";
import QuickKit from "./Series/QuickKit";
import SelectASeries from "./Series/SelectASeries";
import ComingSoonDivider from "../PowerPack_Common/ComingSoonDivider";
import { sortLeftRightTopBottom } from "../../refractCommon/miro/sortLeftRightTopBottom";

const { board } = window.miro;

const buffer = 300;

export default function SeriesTools({
  boardSelection,
  userIsPro,
  environment,
}) {
  const [copies, setCopies] = useState(1);
  // const [duplicateSelectionArray, setDuplicateSelectionArray] = useState([]);
  const [
    selectionArrayThatWillBeFilledWithSeries,
    setSelectionArrayThatWillBeFilledWithSeries,
  ] = useState([]);

  // const [increment, setIncrement] = useState(1);
  // const [startNumber, setStartNumber] = useState(1);
  // const [maxStepCount, setMaxStepCount] = useState(10);

  useEffect(() => {
    runSortThenFilterThenSetSelectionItemsForFill(boardSelection);
  }, [boardSelection]);

  // // Fill with list item type icons
  // let fillWithListItemTypeIcons = (
  //   <div className="cs4 ce12 grid mt-0 mb-0">
  //     <div className="m2 icon icon-rectangle cs1"></div>
  //     <div className="m2 icon icon-sticky-bulk cs2"></div>
  //     <div className="m2 icon icon-card cs3"></div>
  //     <div className="m2 icon icon-frame cs4"></div>
  //     <div className="m2 icon icon-text cs5"></div>
  //   </div>
  // );

  //DUPLICATE
  function runSortThenFilterThenSetSelectionItemsForFill(selection) {
    let leftRightSortedArray = sortLeftRightTopBottom(selection);
    if (!leftRightSortedArray) {
      return [];
    }
    if (leftRightSortedArray.length === 0) {
      setSelectionArrayThatWillBeFilledWithSeries([]);
      return selection;
    }
    if (leftRightSortedArray.length > 0) {
      let filteredSelection = leftRightSortedArray.filter(
        (item) =>
          item.type === "sticky_note" ||
          item.type === "shape" ||
          item.type === "text" ||
          item.type === "card" ||
          item.type === "frame"
      );
      setSelectionArrayThatWillBeFilledWithSeries(filteredSelection);
    }
  }

  /* ---------------------------------------------------------- */
  // Functional Component returning JSX
  return (
    <div>
      <QuickKit />

      <SelectASeries
        boardSelection={boardSelection}
        selectionArrayThatWillBeFilledWithSeries={
          selectionArrayThatWillBeFilledWithSeries
        }
      />

      <ComingSoonDivider visible={true} />

      <div className="tool-section grid mt-16 pos-rel">
        <div className="centered-overlay crosshatch"></div>
        <div className="icon m2 icon-collapse cs1"></div>
        <h3 className="h3 cs2 ce12 mt-0 mb-0">Save Your Own Series</h3>{" "}
        <p className="p-medium mt-0 mb-0 cs1 ce12">
          Save a series or Quick Kit.
        </p>
      </div>
    </div>
  );

  /* ---------------------------------------------------------- */
}

// // Duplicate item type icons
// let DuplicateItemTypeIcons = (
//   <div className="cs4 ce12 grid mt--8 mb-0">
//     <div className="m2 icon icon-rectangle cs1"></div>
//     <div className="m2 icon icon-sticky-bulk cs2"></div>
//     <div className="m2 icon icon-card cs3"></div>
//     <div className="m2 icon icon-frame cs4"></div>
//     <div className="m2 icon icon-text cs5"></div>
//   </div>
// );
{
  /*  */
}
{
  /* <div className="icon m2 icon-duplicate mt-16"></div>
          <h4 className="h4 cs2 ce12 mt-16 mb-0">
            Duplicate Amount from a Template Item
          </h4>

          <div className="grid cs1 ce12 mt-0">
            <p className="p-small cs1 ce3 mt-0 mb-0 softer-help text-align-right">
              # Duplicates <br></br> <i>100 or less</i>
            </p>
            <input
              name="copies"
              type="number"
              className="cs4 ce6 input input-small"
              placeholder="1"
              min="1"
              max="100"
              value={copies}
              onChange={(e) => setCopies(e.target.value)}
            />
            <button
              className="button button-secondary fix-button-secondary button-small mt-0 cs7 ce12"
              onClick={runDuplicateSelection}>
              Duplicate Selected
            </button>
          </div>
           */
}
{
  /* <div className="cs1 icon m2 mt-16 icon-cursor-user mb-8"></div>

          <h3 className="h3 cs2 ce12 mt-16 mb-8">Select Your Series</h3> */
}
